var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 94,
    viewBox: "0 0 46 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0 10.2974 10.2975 0 23 0C35.7025 0 46 10.2975 46 23V71C46 83.7026 35.7025 94 23 94C10.2975 94 0 83.7025 0 71V23Z",
    fill: "#F3B000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1161 78.3839C22.6043 78.872 23.3957 78.872 23.8839 78.3839L31.8388 70.4289C32.327 69.9408 32.327 69.1493 31.8388 68.6612C31.3507 68.173 30.5592 68.173 30.0711 68.6612L23 75.7322L15.9289 68.6612C15.4408 68.173 14.6493 68.173 14.1612 68.6612C13.673 69.1493 13.673 69.9408 14.1612 70.4289L22.1161 78.3839ZM21.75 47L21.75 77.5L24.25 77.5L24.25 47L21.75 47Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cbe329d920956add9ca211e4d8a512b9.svg";
export { ForwardRef as ReactComponent };